import { useModalActions } from 'components/ModalManager/Context';
import { useCallback } from 'react';
import { PreAuthCardModal } from '../CreditCard/PreAuthCardModal';
import { SubscriptionPlan } from '../Plans/constant';

type Props = {
  onSuccess: (plan: SubscriptionPlan) => void;
};
const MODAL_ID = 'pre_credit_auth_dialog';

export const usePreAuthCardModal = ({ onSuccess }: Props) => {
  const { openModal, closeModal } = useModalActions();

  const onClose = (): void => {
    closeModal({ id: MODAL_ID });
  };

  const onConfirm = useCallback(
    (plan: SubscriptionPlan): void => {
      onSuccess(plan);
      onClose();
    },
    [onSuccess, onClose],
  );

  return useCallback(
    (plan: SubscriptionPlan) => {
      return openModal({
        id: MODAL_ID,
        title: '',
        content: <PreAuthCardModal onConfirm={() => onConfirm(plan)} onClose={onClose} planAmount={plan.price.amount} />,
        makeActions: () => null,
      });
    },
    [openModal, onClose],
  );
};
